/**
 * Jotai Provider Setup
 * Configures Jotai with Tanstack Query integration
 */

import { Provider } from 'jotai';
import { queryClientAtom } from 'jotai-tanstack-query';
import { useHydrateAtoms } from 'jotai/utils';
import { queryClient } from './query-client';

interface JotaiProviderProps {
  children: React.ReactNode;
}

function HydrateAtoms({ children }: { children: React.ReactNode }) {
  useHydrateAtoms([[queryClientAtom, queryClient]]);
  return children;
}

export function JotaiProvider({ children }: JotaiProviderProps) {
  return (
    <Provider>
      <HydrateAtoms>{children}</HydrateAtoms>
    </Provider>
  );
}
